var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCirclePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "circle-plus_svg__icon",
    d: "M18 11.719v.562c0 .31-.253.563-.563.563h-4.593v4.594c0 .309-.253.562-.563.562h-.562a.564.564 0 01-.563-.563v-4.593H6.562A.564.564 0 016 12.28v-.562c0-.31.253-.563.563-.563h4.593V6.562c0-.309.253-.562.563-.562h.562c.31 0 .563.253.563.563v4.593h4.594c.309 0 .562.253.562.563zm5.625.281c0 6.422-5.203 11.625-11.625 11.625S.375 18.422.375 12 5.578.375 12 .375 23.625 5.578 23.625 12zm-1.5 0c0-5.62-4.56-10.125-10.125-10.125C6.38 1.875 1.875 6.435 1.875 12c0 5.62 4.56 10.125 10.125 10.125 5.62 0 10.125-4.56 10.125-10.125z",
    fill: "#C4C4C4"
  })));
}

export default __webpack_public_path__ + "./fonts/circle-plus.b2385a4b72a673ca4aaa995c66bcdf8d.svg";
export { SvgCirclePlus as ReactComponent };